import { createSlice } from '@reduxjs/toolkit';
import { fetchJurnal } from '../action/jurnalAction';
const initialState = {
    dopusk: [],
    dopuskDetal: [],
    vidDopusk: []
};
export const jurnalSlice = createSlice({
    initialState,
    name: 'jurnal',
    reducers: {},
    extraReducers: {
        [fetchJurnal.fulfilled.type]: (state, action) => {
            state.dopusk = action.payload.dopusk;
            state.dopuskDetal = action.payload.dopuskDetal;
            state.vidDopusk = action.payload.vidDopusk;
        }
    }
});
export default jurnalSlice.reducer;
